import Link from 'next/link';

import type { FunctionComponent } from 'react';
import type { TypeTabGroupProps, TypeTabsGroups } from './types';

export const TabGroup: FunctionComponent<TypeTabGroupProps> = ({
  className = '',
  tabsgroups,
  color,
}: TypeTabGroupProps) => (
  <div className={`-mx-4 overflow-x-auto md:mx-0 ${className}`}>
    <div className="flex justify-start gap-4 p-4 md:justify-center">
      {tabsgroups?.map((tabGroup: TypeTabsGroups, index: number) => (
        <Link
          href={tabGroup.href}
          prefetch={false}
          key={`${index}_${tabGroup.href}`}
          // Color opcional de Strapi: tiñe texto y borde. Sin valor → estilo
          // neutral actual (las clases neutrals quedan como fallback).
          style={color ? { color, borderColor: color } : undefined}
          className="text-button border-neutrals-100 text-neutrals-900 shrink-0 self-center rounded-full border border-solid px-3 py-2 md:px-4 md:py-2"
        >
          {tabGroup.label}
        </Link>
      ))}
    </div>
  </div>
);

TabGroup.displayName = 'TabGroup';
